import { useFieldConfig } from 'context/fields';
import { EntityType } from 'shared/constants/entityTypes';
import { PORTALVIEW_PERMISSION } from 'shared/constants/fields';
import usePermissionCheck from './usePermissionCheck';

const fieldsToShow = ['estimated_start_date', 'estimated_complete_date'];

// Settings & Enablement mechanics
export default function useRecurrenceParameters() {
  const { getFields } = useFieldConfig();
  const fields = getFields({
    entityType: EntityType.TEST,
    showAllFields: true,
    fieldsToShow,
  });
  const isSettingEnabled = usePermissionCheck(
    PORTALVIEW_PERMISSION.TEST_RECURRENCE_CREATE
  );
  const fieldsShown = fields.length === 2;

  return {
    isEnabled: isSettingEnabled && fieldsShown,
  };
}
